import AccessToRigthsMapper from "../../../components/Mappers/AccessToRigthsMapper"
import Titles from "../../../components/Titles/Titles"
import { EvaluatedRights } from "../../../interfaces/Rights"
import ResponsiveContainer from "../../../layouts/ResponsiveContainer"
import Dropdown from '../../../components/Inputs/Selects/CustomSelect';
import { Period } from "../../../interfaces/Periods";
import Loading from "../../../components/Loading/Loading";
import Warning from "../../../components/Warning/Warning";

interface IQuickAccessToRights {
    quickAccessToRights: EvaluatedRights[],
    periods: Period[],
    lastPeriodSelected: string,
    handleOnChangePeriods: (period: string) => void,
    selectedPeriod: Period,
    loading: "idle" | "pending" | "succeeded" | "failed",
    disclaimer: string,
    isModalOpen: boolean,
    handleModalClose: (isOpen: boolean | ((prevState: boolean) => boolean)) => void;
}

const QuickAccessToRights = ({ quickAccessToRights, periods, lastPeriodSelected, handleOnChangePeriods, selectedPeriod, loading, disclaimer, isModalOpen, handleModalClose }: IQuickAccessToRights) => {

    return (
        <section className="flex flex-col justify-center w-full items-center pt-12 md:pt-13 bg-primary-100 relative">
            {/* Encabezado */}
            <ResponsiveContainer className={`flex gap-2 sm:gap-0 flex-row justify-between items-end insolate ${disclaimer ? '' : 'mb-6'}`}>
                <Titles
                    title={"Derechos"}
                    withBgPattern={false}
                    color='text-brand-green-20'
                />
                <div className="flex items-center gap-3">
                    <Dropdown
                        options={periods}
                        onSelect={handleOnChangePeriods}
                        selectedItem={lastPeriodSelected}
                        defaultSelectedItem={lastPeriodSelected}
                        label=''
                        className='!min-w-[150px] !max-w-[150px]'
                        variant="orange"
                        showLabel={false}
                    />
                    {
                        loading === 'pending'
                            ? <Loading size={26} />
                            : null
                    }
                </div>
            </ResponsiveContainer>
            {/* Advertencia de datos faltantes */}
            {disclaimer && disclaimer.trim().length > 0 &&
                <ResponsiveContainer>
                    <div className={`flex flex-col justify-center w-full items-center ${isModalOpen ? 'my-6' : 'mt-6'}`}>
                        <Warning
                            isOpen={isModalOpen}
                            setIsOpen={handleModalClose}
                            position="relative"
                            text={disclaimer}
                        />
                    </div>
                </ResponsiveContainer>
            }
            <AccessToRigthsMapper
                quickAccessToRights={quickAccessToRights}
                initialSelectedPeriod={selectedPeriod}
            />
        </section>
    )
}

export default QuickAccessToRights